import React, { Component } from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/fontawesome-free-solid";
import "./loader.scss";

export class Loader extends Component {
  render() {
    return (
      <div id="loadingPage">
        <img
          id="logo"
          className="logoSymbol"
          src="/images/logo.png"
          alt="SELPHO"
        />
        <FontAwesomeIcon icon={faSpinner} spin />
        <div className="load-text">טוען...</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PageTemplate/Loader.jsx